// tslint:disable-next-line:no-var-requires
var qs = require('query-string');
export var parseQuery = function (search) {
    return qs.parse(search);
};
export var stringifyQuery = function (query) {
    return qs.stringify(query);
};
//# sourceMappingURL=query.js.map